export interface IChoice {
  id: string;
  name: string;
}

export interface IOption {
  label: string;
  value: string;
}

export interface ISpk {
  name: string;
  lastName: string;
}

export const ParserAlgo = {
  lastName: 'apellido nombre',
  LASTNAME: 'APELLIDOS nombres',
  namesLastn: 'nombre apellidos',
  nameLastn: 'nombres apellido',
};
